/**
 * Formatação canônica do nome da Loja para exibição.
 * Evita duplicação quando `name` já contém "Nº X" e number vem separado.
 * Também normaliza prefixo "A.R.L.S." opcional.
 */

/**
 * Remove sufixo "Nº xxx" ou "nº xxx" do nome (deixando apenas o nome base).
 */
export const stripTrailingNumber = (name) => {
  if (!name) return "";
  return String(name).replace(/\s*[Nn][ºo°]\s*\d+.*$/, "").trim();
};

/**
 * Retorna o nome completo formatado sem duplicação: "Deus, Pátria e Amor nº 789"
 * @param {Object} loja  { name, number }
 * @param {Object} opts  { withArls?: boolean }
 */
export const formatLojaName = (loja, opts = {}) => {
  if (!loja) return "";
  const { withArls = false } = opts;
  const baseName = stripTrailingNumber(loja.name);
  const cleanName = baseName.startsWith("A.R.L.S.") ? baseName.replace(/^A\.R\.L\.S\.\s*/i, "") : baseName;
  const arlsPrefix = withArls ? "A.R.L.S. " : "";
  const numberPart = loja.number ? ` nº ${loja.number}` : "";
  return `${arlsPrefix}${cleanName}${numberPart}`;
};
